import React, { useState, useEffect } from 'react';
import { validateFraxResults } from '../utils/errorHandler';

const Step10 = ({ formData, handleInputChange, setStep, handleSubmit, setIsProcessing, setStatusMessage }) => {
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);

  useEffect(() => {
    sessionStorage.setItem('lastPage', 'Step10');
    
    // セッションストレージを更新し、新しいFRAX計算を必ず実行するようにする
    sessionStorage.removeItem('has_navigated_to_results');
  }, []);

  const handleAnswer = async (answer) => {
    // 既に処理中の場合は二重送信を防止
    if (loading) {
      console.log('既に処理中のため、リクエストをスキップします');
      return;
    }
    
    // formDataを更新
    handleInputChange({
      target: {
        name: 'secondaryOsteoporosis',
        value: answer
      }
    });
    
    setLoading(true);
    setLoadingButton(answer ? 'yes' : 'no');
    setIsProcessing(true);
    setStatusMessage('計算中です。しばらくお待ちください...');
    
    let messageTimers = [];

    try {
      // 計算開始後、時間経過に応じてメッセージを更新
      messageTimers.push(setTimeout(() => {
        setStatusMessage('計算中です。もう少しお待ちください...');
      }, 10000));
      
      messageTimers.push(setTimeout(() => {
        setStatusMessage('計算を続けています。あと少しです…');
      }, 20000));
      
      messageTimers.push(setTimeout(() => {
        setStatusMessage('詳細に計測しています。もう少しです…');
      }, 30000));
      
      // FRAX計算を開始 - 自動リトライはhandleSubmit内で処理
      const result = await handleSubmit();
      
      // すべてのタイマーをクリア
      messageTimers.forEach(timer => clearTimeout(timer));
      
      // リダイレクトも含めた全ての処理はhandleSubmit内で実行されるため
      // ここでは特に何もしない
    } catch (error) {
      console.error('Submit error:', error);
      // すべてのタイマーをクリア
      messageTimers.forEach(timer => clearTimeout(timer));
      
      // エラー処理はhandleSubmit内で行われるため、ここでは特に何もしない
      // setStatusMessage()の呼び出しも不要
    } finally {
      // 注意: handleSubmit内で全ての処理が完了するまで
      // loading状態は維持される
    }
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 10</h2>
      <p className="text-base mb-4 text-lg">過去に以下の病気と診断されたことはありますか？<br />
        <br />※以下のうちひとつでも医師から診断されたことがある場合は、「はい」を選んでください。<br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <ul className="text-regular text-lg list-disc list-inside mb-5">
        <li>１型糖尿病(インスリン依存性糖尿病)</li>
        <li>骨形成不全症</li>
        <li>長期にわたり未治療であった甲状腺機能亢進症</li>
        <li>性機能低下症あるいは早発閉経(45歳未満)</li>
        <li>慢性的な栄養失調</li>
        <li>吸収不良および慢性肝疾患</li>
      </ul>
      
      <br />
      <div className="flex justify-between items-center">
        <button 
          onClick={() => setStep(10)} 
          className={`bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={loading}
        >
          前の画面へもどる
        </button>
        
        <div className="flex items-center">
          {loading && loadingButton === 'yes' && (
            <svg className="loader mr-2" width="40" height="40" viewBox="-60 -60 120 120">
              <circle r="50" />
            </svg>
          )}
          <button 
            onClick={() => handleAnswer(true)} 
            className={`bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={loading}
          >
            {loading && loadingButton === 'yes' ? '危険度を計測中...' : 'はい'}
          </button>
        </div>
        <div className="flex items-center">
          {loading && loadingButton === 'no' && (
            <svg className="loader mr-2" width="40" height="40" viewBox="-60 -60 120 120">
              <circle r="50" />
            </svg>
          )}
          <button 
            onClick={() => handleAnswer(false)} 
            className={`bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={loading}
          >
            {loading && loadingButton === 'no' ? '危険度を計測中...' : 'いいえ'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step10; 